module.exports = __webpack_public_path__ + "img/astral_24.586c9051.svg";